<modal-container
  #modal
  [headerIconClass]="'fa-download'"
  [headerTitle]="'import.do'"
  [ignoreBackdropClick]="true"
  [isLargeModal]="!!skippedOrders?.length || !!skippedProducts?.length || !!errors?.length"
>
  <ng-container class="modal-button-show">
    <btn
      [label]="'import.do'"
      [title]="'import.do' | translate"
      [icon]="'far-download'"
      [isLoading]="loading"
      [spinnerClassesString]="'spinner-blue'"
      [classes]="['btn-third', 'me-2']"
      (onEvent)="showChildModal()"
      [attr.data-cy]="dataCyAttribute"
    ></btn>
  </ng-container>

  <ng-container class="modal-body-content">
    <div class="card">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      @if (!isImportMapUpdating && !isImportMapSet) {
        <div>
          <div class="row">
            <div class="col-6">
              <form-row-select
                [label]="'batch.file.type'"
                [icon]="'far-list'"
                [(model)]="selectedFileType"
                [options]="fileTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'checkout'"
                [icon]="'far-money-bill'"
                [(model)]="selectedCheckout"
                [options]="checkouts"
                [dataCyAttribute]="'modal-orders-import-checkout'"
              ></form-row-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 ps-0 pe-0" style="font-size: 12px">
              @if (selectedFileType === 'depoto-orders.xlsx') {
                <div class="col-12 flex-gap-5 align-items-center">
                  <span>{{ 'modal-orders-import.template' | translate }}</span>
                  <a
                    class="inline-flex-gap-5 align-items-center"
                    [href]="templatesURL + 'depoto-orders' + ('lang-url-fragment' | translate) + '.tpl.xlsx'"
                  >
                    <span class="far fa-file-download"></span>
                    <span>depoto-orders.tpl.xlsx</span>
                  </a>
                </div>
              }
              @if (selectedFileType === 'go-orders.csv') {
                <div class="col-12 flex-gap-5 align-items-center">
                  <span>{{ 'modal-orders-import.template' | translate }}</span>
                  <a class="inline-flex-gap-5 align-items-center" [href]="templatesURL + 'go-orders.tpl.csv'">
                    <span class="far fa-file-download"></span>
                    <span>go-orders.tpl.csv</span>
                  </a>
                </div>
              }
              @if (selectedFileType === 'flexibee-order.xml') {
                <div class="col-12 flex-gap-5 align-items-center">
                  <span>{{ 'modal-orders-import.template' | translate }}</span>
                  <a
                    class="inline-flex-gap-5 align-items-center"
                    [href]="'https://www.flexibee.eu/api/doc/priklady-xml/faktura-vydana-full.xml'"
                    target="_blank"
                  >
                    <span class="far fa-file-download"></span>
                    <span>flexibee-order.xml</span>
                  </a>
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <form-row-input
                [label]="'file'"
                [icon]="'far-upload'"
                [inputType]="'file'"
                [appendBtnLabel]="'load'"
                [appendBtnClasses]="['btn-input']"
                [dataCyAttribute]="'modal-orders-import-file'"
                (valueChangeNative)="finalMessage = ''; loadFile($event)"
                (onAppendBtnEvent)="handleImportFile()"
              ></form-row-input>
            </div>
          </div>
        </div>
      }
      @if (isImportMapSet) {
        <progressbar type="success" [value]="progress" [striped]="true" [max]="100"></progressbar>
      }
      @if (finalMessage) {
        <div role="alert" class="alert mt-2" [ngClass]="finalMessageClass">
          <b>{{ finalMessage }}</b>
        </div>
      }
      @if (isImportMapUpdating) {
        <div class="mt-2" data-cy="modal-orders-import-mapping">
          <h3>{{ 'modal-orders-import.check-column-layout' | translate }}</h3>
          <div class="row">
            <div class="col-6">
              <form-row-select
                [label]="'orderFulltext.number'"
                [(model)]="importMap.reservationNumber"
                [options]="columnTypes"
                [dataCyAttribute]="'modal-orders-import-column-reservation-number'"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select [label]="'ean'" [(model)]="importMap.ean" [options]="columnTypes"></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'code'"
                [(model)]="importMap.code"
                [options]="columnTypes"
                [dataCyAttribute]="'modal-orders-import-column-code'"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'product.name'"
                [(model)]="importMap.productName"
                [options]="columnTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'quantity'"
                [(model)]="importMap.quantity"
                [options]="columnTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'firstName'"
                [(model)]="importMap.firstName"
                [options]="columnTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'lastName'"
                [(model)]="importMap.lastName"
                [options]="columnTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'street'"
                [(model)]="importMap.street"
                [options]="columnTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select [label]="'city'" [(model)]="importMap.city" [options]="columnTypes"></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select [label]="'zip'" [(model)]="importMap.zip" [options]="columnTypes"></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'country'"
                [(model)]="importMap.country"
                [options]="columnTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select [label]="'phone'" [(model)]="importMap.phone" [options]="columnTypes"></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select [label]="'email'" [(model)]="importMap.email" [options]="columnTypes"></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'payment.type'"
                [(model)]="importMap.paymentType"
                [options]="columnTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'payment.amount'"
                [(model)]="importMap.paymentAmount"
                [options]="columnTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'currency'"
                [(model)]="importMap.currency"
                [options]="columnTypes"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select
                [label]="'carrier'"
                [(model)]="importMap.carrier"
                [options]="columnTypes"
                [dataCyAttribute]="'modal-orders-import-column-carrier'"
              ></form-row-select>
            </div>
            <div class="col-6">
              <form-row-select [label]="'note'" [(model)]="importMap.note" [options]="columnTypes"></form-row-select>
            </div>
          </div>
          <btn
            [btnType]="'button'"
            [label]="'continue'"
            [title]="'continue' | translate"
            (onEvent)="setImportMapAndContinue()"
          ></btn>
        </div>
      }
      @if (isImportFileLoaded) {
        <div class="mt-2">
          <alert type="info">{{ orders.length }} {{ 'modal-orders-import.items-ready' | translate }}</alert>
        </div>
      }
      @if (skippedOrders.length > 0) {
        <div class="mt-2">
          <div class="import-issue-heading">{{ 'modal-orders-import.skipped-orders' | translate }}</div>
          <div class="import-issue-list">
            @for (skippedOrder of skippedOrders; track skippedOrder) {
              <alert type="warning">{{ skippedOrder }}</alert>
            }
          </div>
        </div>
      }
      @if (skippedProducts.length > 0) {
        <div class="mt-2">
          <div class="import-issue-heading">{{ 'modal-orders-import.skipped-products' | translate }}</div>
          <div class="import-issue-list">
            @for (skippedProduct of skippedProducts; track $index) {
              <alert type="warning">
                {{ skippedProduct.orderItemName }}
                @if (skippedProduct.ean) {
                  <br />
                  {{ ('ean' | translate) + ':&nbsp;' + skippedProduct.ean }}
                }
                <br />
                {{
                  ('modal-orders-import.quantityAvailable' | translate) +
                    skippedProduct.quantityAvailable +
                    ('piece' | translate) +
                    ',&nbsp;' +
                    ('modal-orders-import.quantityInOrder' | translate) +
                    skippedProduct.orderQuantity +
                    ('piece' | translate)
                }}
              </alert>
            }
          </div>
        </div>
      }
      @if (errors && errors.length > 0) {
        <div class="mt-2">
          <div class="import-issue-heading">
            {{
              (hasImportRun ? 'modal-orders-import.not-imported' : 'modal-orders-import.will-not-import') | translate
            }}
          </div>
          @if (importIssues.length > 0) {
            <div class="import-issue-section mt-2">
              <span class="import-issue-badge">{{ 'modal-orders-import.import-error' | translate }}</span>
              <div class="import-issue-list">
                @for (issue of importIssues; track issue) {
                  <alert type="danger">{{ issue.message }}</alert>
                }
              </div>
            </div>
          }
          @if (fileIssues.length > 0) {
            <div class="import-issue-section mt-2">
              <span class="import-issue-badge">{{ 'modal-orders-import.file-error' | translate }}</span>
              <div class="import-issue-list">
                @for (issue of fileIssues; track issue) {
                  <alert type="danger">{{ issue.message }}</alert>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </ng-container>

  <ng-container class="modal-footer-content">
    <btn
      [label]="'import.do'"
      [title]="'import.do' | translate"
      [icon]="'far-download'"
      [classes]="['btn-first']"
      [btnDisabled]="!isImportFileLoaded || loading"
      (onEvent)="import()"
    ></btn>
  </ng-container>
</modal-container>
